import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DisplayValidationErrorsDirective, IListingForm, ToggleComponent } from '@curbnturf/form-helpers';

@Component({
  selector: 'curbnturf-hazard-input',
  templateUrl: './hazard-input.component.html',
  styleUrls: ['./hazard-input.component.scss'],
  standalone: true,
  imports: [ToggleComponent, NgIf, FormsModule, ReactiveFormsModule, DisplayValidationErrorsDirective],
})
export class HazardInputComponent {
  @Input() form: FormGroup<IListingForm>;

  get potentialHazards(): FormControl<boolean | null> | undefined {
    if (this.form) {
      return this.form.controls.potentialHazards;
    }

    return;
  }

  get potentialHazardDescription(): FormControl<string | null> | undefined {
    if (this.form) {
      return this.form.controls.potentialHazardDescription;
    }

    return;
  }

  selected(): boolean {
    if (!this.potentialHazards) {
      return false;
    }

    return this.potentialHazards.value || false;
  }

  togglePotentialHazards() {
    if (!this.potentialHazards) {
      return;
    }

    if (this.selected()) {
      this.potentialHazards.setValue(false);
    } else {
      this.potentialHazards.setValue(true);
    }
    this.potentialHazards.markAsDirty();
  }
}
